import { http } from "./http.js";

export const get = (url, options) => http.get(url, options);
